import { render, staticRenderFns } from "./tab-tertiary.vue?vue&type=template&id=0827a31b&scoped=true&"
import script from "./tab-tertiary.vue?vue&type=script&lang=js&"
export * from "./tab-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827a31b",
  null
  
)

export default component.exports